var _defs, _use, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg10D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 99.5,
    x2: 232.6,
    y1: 30.7,
    y2: 261.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 78,
    x2: 118,
    y1: 63.4,
    y2: 132.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 1308.3,
    x2: 1317.8,
    y1: -657.9,
    y2: -633.3,
    gradientTransform: "rotate(-9 7158.052 6929.531)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b65ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0a5ad4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0950bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "i",
    x1: 1363.6,
    x2: 1373.1,
    y1: -649.2,
    y2: -624.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "j",
    x1: 1419,
    x2: 1428.4,
    y1: -640.4,
    y2: -615.8
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    viewBox: "0 0 196 196"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 98,
    r: 40,
    fill: "url(#b)",
    stroke: "#f8af18",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 12,
    d: "M98 31.4V6m0 184v-25.4M145.1 51l18-17.9M33 163l18-17.9M51 51 33 33m130.1 130.1-18-18M6 98h25.4M190 98h-25.4"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 98 98; 45 98 98"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "m291 107-2.5.1A83.9 83.9 0 00135.6 43 56 56 0 0051 91a56.6 56.6 0 00.8 9A60 60 0 0063 219l4-.2v.2h224a56 56 0 000-112Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "f",
    viewBox: "0 0 363 258"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 196,
    height: 196
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: 350,
    height: 222,
    transform: "translate(13 36)"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    width: 363,
    height: 258,
    transform: "translate(68 109)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    d: "M200 376a8 8 0 01-8-8v-12a8 8 0 0116 0v12a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "g",
    additive: "sum",
    attributeName: "transform",
    begin: "0s; g.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    type: "translate",
    values: "0 -32; 0 -32; 0 120;"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "h",
    attributeName: "opacity",
    begin: "0s; h.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    d: "M256 376a8 8 0 01-8-8v-12a8 8 0 0116 0v12a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x2",
    additive: "sum",
    attributeName: "transform",
    begin: "1.34s; x2.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    type: "translate",
    values: "0 -32; 0 -32; 0 120;"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y2",
    attributeName: "opacity",
    begin: "1.34s; y2.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    stroke: "#0a5ad4",
    strokeMiterlimit: 10,
    d: "M312 376a8 8 0 01-8-8v-12a8 8 0 0116 0v12a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "k",
    additive: "sum",
    attributeName: "transform",
    begin: ".67s; k.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    type: "translate",
    values: "0 -32; 0 -32; 0 120;"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "l",
    attributeName: "opacity",
    begin: ".67s; l.end+1s",
    dur: "1s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg10D);
export default __webpack_public_path__ + "static/media/10d.93f4578bbdcdf91f689c9cc43f9e470a.svg";
export { ForwardRef as ReactComponent };